import apiCalls from '../api/apiCalls'
const USER_EXPIRED = 'redux-oidc/USER_EXPIRED'
const SILENT_RENEW_ERROR = 'redux-oidc/SILENT_RENEW_ERROR'
const USER_EXPIRING = 'redux-oidc/USER_EXPIRING'
const USER_FOUND = 'redux-oidc/USER_FOUND'
const USER_LOG_OUT = "userLogout";
const GET_PROFILE_SUCCESS = "getProfileSuccess";
const SET_DEVICE_TOKEN = "setDeviceToken";
const SET_ADMIN_DETIALS = "setAdminDetails";
const CLEAR_PROFILE = "clearProfile";
const ADMIN_PROFILEIMG = "adminProfileImg";
const FETCH_TRACK_AUDITLOGS = "fetchtrackauditlogs";
const SET_USER_ID = 'setUserID';
const userLogout = () => {
    return {
        type: USER_LOG_OUT
    }
};
const profileSuccess = (info) => {
    return {
        type: GET_PROFILE_SUCCESS,
        payload: info
    }
}
const setToken = (payload) => {
    return {
        type: SET_DEVICE_TOKEN,
        payload
    }
}
const setAdminDetails = (payload) => {
    return {
        type: SET_ADMIN_DETIALS,
        payload
    }
}
const fetchtrackauditlogs = (payload) => {
    return {
        type: FETCH_TRACK_AUDITLOGS,
        payload
    }
};
const getAdminDetails = () => {
    return async (dispatch) => {
        const response = await apiCalls.fetchAdminDetails();
        if (response.ok) {
            dispatch(setAdminDetails(response.data))
        }
    }
}
const getIpRegisteryData = () => {
    return async (dispatch) => {
        await apiCalls.getIpStack().then((res) => {
            var userAgent = window.navigator.userAgent;
            var Browser = userAgent.match(/(chrome|firefox|msie|trident(?=\/))\/?\s*(\d+)/i)[1];
            var version = userAgent.match(/(chrome|firefox|msie|trident(?=\/))\/?\s*(\d+)/i)[2];
            var osRegex = /(Windows NT|Mac OS X|Linux|iPhone|iPad|iPod|Android)[^\s;)]*/i;
            var osMatch = userAgent.match(osRegex);
            var operatingSystem = osMatch ? osMatch[0] : "Unknown";
            const start = userAgent.indexOf('(') + 1;
            const end = userAgent.indexOf(')');
            const deviceInfo = userAgent.substring(start, end);
            const deviceName = deviceInfo.split(';')[0].trim();
            if (res.ok) {
                let ipInfo = {
                    "Ip": res.data.ip,
                    "Location": {
                        "countryName": res.data?.country_name,
                        "state": res.data.region_name,
                        "city": res.data?.city,
                        "postal": res.data?.zip,
                        "latitude": res.data?.latitude,
                        "longitude": res.data?.longitude
                    },
                    "Browser": Browser,
                    "DeviceType": {
                        "name": deviceName,
                        "type": res.data?.type,
                        "version":operatingSystem + " " + version
                    }
                }
                dispatch(fetchtrackauditlogs(ipInfo));
            }
        });
    }
}
const clearProfile = () => {
    return {
        type: CLEAR_PROFILE
    }
}

const adminProfileImg = (payload) => {
    return {
        type: ADMIN_PROFILEIMG,
        payload
    }
}

const setUserID = (payload) => {
    return {
      type: SET_USER_ID,
      payload,
    };
  };

let initialState = {
    user: null,
    custUser:null,
    deviceToken: null,
    adminDetails: null,
    adminProfileImg:null,
    trackAuditLogData: {},
};
const authReducer = (state, action) => {
    if (!state) {
        state = {
            ...initialState,
            ...state
        }
    }
    switch (action.type) {
        case SET_USER_ID:
            state = { ...state, custUser: action.payload };
            return state;
        case USER_FOUND:
            return { ...state, user: action.payload }
        case USER_EXPIRING:
            return state;
        case USER_LOG_OUT:
            return { user: null, profile: null, adminDetails: null };
        case USER_EXPIRED:
            return { user: null, profile: null, adminDetails: null };
        case GET_PROFILE_SUCCESS:
            return { ...state, profile: action.payload };
        case SET_DEVICE_TOKEN:
            return { ...state, deviceToken: action.payload };
        case SILENT_RENEW_ERROR:
            console.log("Silent renew Error" + action.payload);
            return state;
        case SET_ADMIN_DETIALS:
            state = { ...state, adminDetails: action.payload,user:action.payload };
            return state;
        case CLEAR_PROFILE:
            return { user: null, profile: null, adminDetails: null, trackAuditLogData: {} };
        case ADMIN_PROFILEIMG:
            state = { ...state, adminProfileImg: action.payload };
            return state;
        case FETCH_TRACK_AUDITLOGS:
            state = { ...state, trackAuditLogData: action.payload }
            return state;
        default:
            return state;
    }
}

export default authReducer;
export {setUserID, userLogout, profileSuccess, setToken, getAdminDetails, clearProfile ,adminProfileImg,getIpRegisteryData, fetchtrackauditlogs};

